var RecentLocations, RecentSearches, allTranslations, createBloodhoundTag, deEmphasis, getAutocompleteList, getHeadingPartial, getRecentSearches, getSubCategoryCollection, getTranslations, matchListItem, moveAutocomplete, normalizeQuery, partialAutocompleteList, partialCurrentLocation, partialLocationHelper, partialRecentSearchesList, partialSearchCategories, partialSearchCategoryList, prepareBloodhoundTag, removeRecentSearch, removeRecentSearches, saveRecentSearch, setRecentSearches, setTranslations, templateAttributesForSubcategories, toCamelCase,
  slice = [].slice;

normalizeQuery = require('./m_normalizeQuery');

toCamelCase = require('../../../../../src/helpers/camelCase').toCamelCase;


/*
 * @type {Object} allTranslations Global closure to cache translations
 */

allTranslations = {};


/*
 * @type {Array} RecentSearches Global closure to cache recent searches terms
 */

RecentSearches = [];


/*
 * @type {Array} RecentLocations Global closure to cache recent location searches
 */

RecentLocations = [];


/*
 * Injects html tags to separate the neighborhood and the city
 *
 * @param   {String} label - Location with strong tags
 * @returns {String}
 */

deEmphasis = function(label) {
  var res;
  res = label.split(/,(.+)?/);
  if (res.length < 2) {
    return label;
  }
  if (res[0].includes('</strong>') || res[1].includes('<strong>')) {
    res.splice(1, 0, '<em>');
  } else {
    res.splice(1, 0, '</strong><em><strong>');
  }
  res.splice(3, 0, '</em>');
  return res.join('');
};


/*
 * Generate basic bloodhound tag name
 *
 * @param   {String} [type]     - Name of the api / collection name
 * @param   {String} attributes
 * @returns {String} bhw        - Base bloodhound tag
 */

createBloodhoundTag = function(type) {
  var bhw;
  if (type == null) {
    type = '';
  }
  type = type.split('|').map(function(i) {
    return toCamelCase(i);
  }).join('');
  bhw = "TouchSearchCategory" + type;
  return bhw;
};


/*
 * Method to build general (deal|location) autocomplete partial
 *
 * @param   {Array}  collections           - List of items returned from autocomplete
 * @param   {String} normQuery             - Normalized term entered by user
 * @param   {Number} [indexShift]          - Shift the index e.g due to previously processed collection
 * @returns {Object} {list, index, prefix}
 */

partialAutocompleteList = function(collections, normQuery, indexShift) {
  var index, item, label, lat, len, list, lng, locationPartial, n, queryLength, template, value;
  if (indexShift == null) {
    indexShift = 0;
  }
  queryLength = normQuery.length + 2;
  len = collections.length - 1;
  index = -1;
  list = [];
  locationPartial = '';
  while (item = collections.shift()) {
    lat = item.lat, lng = item.lng, label = item.label, value = item.value;
    if (lat) {
      locationPartial = " data-lat='" + lat + "' data-lng='" + lng + "'";
      if (item.neighborhood) {
        label = deEmphasis(label);
      }
    }
    n = len - collections.length;
    if (queryLength >= value.length && normQuery === normalizeQuery(value)) {
      index = n + indexShift;
    }
    template = "<li role='listitem' class='tw-item'>\n<a class='tw-link' id='tw" + n + "' tabindex='0' data-bhc='result-" + n + ":" + value + "' data-value='" + value + "'" + locationPartial + ">" + label + "</a>\n</li>";
    list.push(template);
  }
  return {
    list: list,
    index: index,
    prefix: 'tw'
  };
};


/*
 * LS-2211 current location / geolocation
 * Adds geolocation partial and handles matching
 *
 * @param   {String} widget         - Widget name
 * @param   {String} normQuery      - Normalized term user entered
 * @param   {Number} index          - Matched item index
 * @returns {Object} {list, index}
 */

partialCurrentLocation = function(widget, normQuery, index) {
  var list, normLabel, template, translations;
  translations = getTranslations();
  normLabel = normalizeQuery(translations.search.currentlocation);
  template = "<li role='listitem'>\n<a class='current-location icon-compass-needle tw-link' tabindex='0' data-value='" + translations.search.currentlocation + "' data-bhw='" + widget + "'>" + translations.search.currentlocation + "</a>\n</li>";
  list = [template];
  if (index > -1) {
    index = index + 1;
  }
  if (normQuery === normLabel) {
    index = index + 1;
  }
  return {
    list: list,
    index: index
  };
};


/*
 * LS-2685 Location Helper message
 * Adds message to help users when searching locations
 *
 * @returns {Array}
 */

partialLocationHelper = function() {
  var template, text, translations;
  translations = getTranslations();
  text = translations.search.helpermsg;
  template = "<li role='listitem'>\n<span class='tw-msg ls-location-helper'><span class=\"new-badge\">NEW</span>" + text + "</span>\n</li>";
  return [template];
};


/*
 * Adds recent searches partial
 *
 * @param   {String} widget         - Widget name
 * @param   {Array}  collection     - List of items to build recent searches widget
 * @param   {Object} [config]       - Configuration containing experiments settings, etc. (Optional)
 * @returns {Object} {list, prefix}
 */

partialRecentSearchesList = function(widget, collection, config) {
  var address, bhc, clearingHeadingPartial, clearingPartial, ctx, division, hasClearingExperiment, item, lat, list, lng, n, ref, template, text, translations;
  if (config == null) {
    config = {};
  }
  translations = getTranslations();
  list = [];
  text = '';
  n = 0;
  clearingPartial = '';
  clearingHeadingPartial = '';
  if ((hasClearingExperiment = (ref = config.experiments) != null ? ref['LS-1744-clear-recent-searches'] : void 0) && (hasClearingExperiment != null ? hasClearingExperiment.setClearX : void 0)) {
    clearingPartial = "<span class='tw-clear icon-x' tabindex='0' aria-label='" + translations.ax.remove + "'></span>";
  }
  switch (widget) {
    case 'recentSearches':
      text = translations.search.recentdeals;
      ctx = 'deal';
      while (item = collection.shift()) {
        bhc = prepareBloodhoundTag(item);
        template = "<li role='listitem' class='tw-item tw-recent'>\n<a class='tw-link' id='twr" + n + "' tabindex='0' data-bhc='" + widget + ":" + bhc + "' data-value='" + item + "'>" + item + "</a>" + clearingPartial + "\n</li>";
        list.push(template);
        n++;
      }
      break;
    case 'recentLocations':
      text = translations.search.recentlocations;
      ctx = 'location';
      while (item = collection.shift()) {
        lat = item.lat, lng = item.lng, address = item.address, division = item.division;
        bhc = prepareBloodhoundTag(address);
        division = division ? "data-division='" + division + "'" : '';
        template = "<li role='listitem' class='tw-item tw-recent'>\n<a class='tw-link' id='twr" + n + "' tabindex='0' data-bhc='" + widget + ":" + bhc + "' data-lat='" + lat + "' data-lng='" + lng + "' data-value='" + address + "' " + division + ">" + address + "</a>" + clearingPartial + "\n</li>";
        list.push(template);
        n++;
      }
  }
  if (list.length) {
    if (hasClearingExperiment && (hasClearingExperiment != null ? hasClearingExperiment.setClearAll : void 0)) {
      clearingHeadingPartial = "<span class='tw-clear' ctx='" + ctx + "'>" + translations.search.clearall + "</span>";
    }
    list.unshift("<li class='tw-heading tw-recent'>" + text + clearingHeadingPartial + "</li>");
  }
  return {
    list: list,
    prefix: 'twr'
  };
};


/*
 * Build L1 Category header partial
 *
 * @param   {String}  type           - category type
 * @returns {String}  partial        - HTML partial containing L0 category heading
 */

getHeadingPartial = function(type) {
  var partial, translations, txt;
  translations = getTranslations();
  partial = '';
  txt = translations != null ? translations.categories[type] : void 0;
  return partial = txt ? "<div class='tw-heading tw-" + type + "'>" + txt + "</div>" : '';
};

templateAttributesForSubcategories = function() {
  var args, ariaAttributes, ariaListAttributes, bhw, catInfo, htmlCloseTag, htmlOpenTag, id, menuID, prefix, sectionID;
  args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
  id = args[0], sectionID = args[1], prefix = args[2], bhw = args[3];
  htmlOpenTag = 'span class="icon-plus tw-caption"';
  htmlCloseTag = 'span';
  menuID = prefix + "tw-" + id + "-menu";
  ariaAttributes = " role='link' aria-controls='" + menuID + "' aria-owns='" + menuID + "' aria-haspopup='true' ";
  catInfo = " cat='" + id + "' cat-path='" + sectionID + "|" + id + "'";
  ariaListAttributes = ' aria-live="polite"';
  return [htmlOpenTag, htmlCloseTag, ariaAttributes, ariaListAttributes, catInfo];
};


/*
 * Build Category partial
 *
 * @param   {Array}   collection - List of items
 * @param   {String}  sectionID  - category section name
 * @param   {Number}  [level]    - Optional parameter representing the taxonomy
 * @param   {Number}  [prefix]   - Optional prefix for id generation
 * @returns {String}             - HTML String
 */

partialSearchCategoryList = function(collection, sectionID, level, prefix) {
  var ariaAttributes, ariaListAttributes, attributes, baseBHW, baseObject, baseUrl, bhw, catInfo, count, countString, friendlyName, htmlCloseTag, htmlOpenTag, id, item, list, menuID, newBadge, newBadgeTag, newBadgeTxt, subcategories, template, url;
  if (level == null) {
    level = 1;
  }
  if (prefix == null) {
    prefix = '';
  }
  if (!(collection != null ? collection.length : void 0)) {
    return '';
  }
  list = [];
  url = '';
  baseBHW = createBloodhoundTag(sectionID);
  baseObject = collection.shift();
  baseUrl = baseObject.baseUrl;
  if (!baseUrl) {
    baseUrl = false;
    collection.unshift(baseObject);
  }
  while (item = collection.shift()) {

    /*
     * item can be either of type "Array" or "Object"
     * API facets are normally mapped as arrays
     * while config or constructed entries (all deals) ar
     * mapped as object.
     */
    if (Array.isArray(item)) {
      if (!baseUrl) {
        continue;
      }
      id = item[0], friendlyName = item[1], count = item[2], subcategories = item[3];
      url = baseUrl + id;
    } else {
      id = item.i, friendlyName = item.n, count = item.c, subcategories = item.s, url = item.u, newBadge = item.newBadge;
    }
    ariaAttributes = ariaListAttributes = catInfo = newBadgeTag = '';
    countString = count ? " <span class='tw-count'>(" + count + ")</span>" : '';
    bhw = id ? baseBHW + toCamelCase(id) : baseBHW + 'AllDeal';
    if (newBadge && (newBadgeTxt = allTranslations.general.newbadge)) {
      newBadgeTag = "<span class='new-badge'>" + newBadgeTxt + "</span>";
    }
    if (subcategories != null ? subcategories.length : void 0) {
      attributes = templateAttributesForSubcategories(id, sectionID, prefix, bhw);
      htmlOpenTag = attributes[0], htmlCloseTag = attributes[1], ariaAttributes = attributes[2], ariaListAttributes = attributes[3], catInfo = attributes[4];
    } else {
      url = url ? "href='" + url + "' " : '';
      htmlOpenTag = "a " + url + "class='tw-link'";
      htmlCloseTag = 'a';
    }
    template = "<li class='tw-item tw-cat-item tw-cat-L" + level + "'" + ariaListAttributes + ">\n<" + htmlOpenTag + " data-bhw='" + bhw + "' " + catInfo + " " + ariaAttributes + ">" + newBadgeTag + friendlyName + countString + "</" + htmlCloseTag + ">\n</li>";
    list.push(template);
  }
  if (list.length) {
    menuID = sectionID.split('|').pop();
    list.unshift("<ul id='" + prefix + "tw-" + menuID + "-menu' class='tw-cat-menu tw-cat-menu-L" + level + "'>");
    list.push("</ul>");
  }
  return list.join('');
};


/*
 * Build Category lists and wrap them
 *
 * @param   {Array}   collections    - List of items
 * @param   {Array}   [prefix]       - Prefix for id generation (Optional)
 * @param   {Boolean} [m2016]        - Mobile2016 flag (Optional)
 * @returns {Object}  {list[]}       - List of categories
 */

partialSearchCategories = function(collections, prefix, m2016) {
  var collection, heading, item, listItems, type;
  if (prefix == null) {
    prefix = '';
  }
  if (m2016 == null) {
    m2016 = true;
  }
  item = collections[0];
  listItems = [];
  for (type in item) {
    collection = item[type];
    if (collection != null ? collection.length : void 0) {
      heading = getHeadingPartial(type);
      listItems.push("<li id='" + prefix + "tw-" + type + "' class='tw-category'>" + heading);
      listItems.push(partialSearchCategoryList(collection.slice(0), type, 1, prefix, m2016));
      listItems.push("</li>");
    }
  }
  return {
    list: listItems
  };
};


/*
 * Global method to generate the autocomplete list
 *
 * @param   {Array}  collections               - List of collections to process
 * @param   {String} query                     - Term entered by user
 * @param   {Object} [config]                  - Config object
 * @returns {Object} {list, index, bh, prefix}
 */

getAutocompleteList = function(collections, query, config) {
  var bh, data, finalList, index, indexShift, j, len1, list, normQuery, prefix, ref, ref1, ref2, ref3, ref4, ref5, tempList, widget;
  if (config == null) {
    config = {};
  }
  tempList = [];
  index = -1;
  indexShift = 0;
  prefix = '';
  normQuery = normalizeQuery(query);
  for (j = 0, len1 = collections.length; j < len1; j++) {
    ref = collections[j], data = ref.collection, widget = ref.widget;
    switch (widget) {
      case 'autocomplete':
        if (query) {
          ref1 = partialAutocompleteList(data, normQuery, indexShift), list = ref1.list, index = ref1.index, prefix = ref1.prefix;
        }
        break;
      case 'helperMessage':
        list = partialLocationHelper();
        break;
      case 'geolocation':
        ref2 = partialCurrentLocation(widget, normQuery, index), list = ref2.list, index = ref2.index;
        indexShift += list.length;
        break;
      case 'recentLocations':
        ref3 = partialRecentSearchesList(widget, data, config), list = ref3.list, prefix = ref3.prefix;
        break;
      case 'recentSearches':
        ref4 = partialRecentSearchesList(widget, data, config), list = ref4.list, prefix = ref4.prefix;
        break;
      case 'searchCategories':
        list = partialSearchCategories(data).list;
    }
    tempList.push.apply(tempList, list);
  }
  bh = widget === 'autocomplete' ? {
    type: 'bhc',
    val: "UserTyped:" + query
  } : {
    type: 'bhw',
    val: toCamelCase(widget)
  };
  ref5 = matchListItem(tempList, index), finalList = ref5.list, index = ref5.index;
  return {
    list: finalList,
    index: index,
    bh: bh,
    prefix: prefix
  };
};


/*
 * Get translations
 *
 * @param   {String} [key]
 * @returns {Object} translations - All translations or partial
 */

getTranslations = function(key) {
  var ref, translations;
  if (!Object.keys(allTranslations).length) {
    setTranslations((ref = Groupon.LS) != null ? ref.translations : void 0);
  }
  translations = typeof key === 'string' ? allTranslations[key] : allTranslations;
  return translations || {};
};


/*
 * Returns list of recent searches queries retrieved from localStorage
 *
 * param    {String} - Input type
 * @returns {Array}  - list
 */

getRecentSearches = function(type) {
  var list, ref, ref1;
  if (type == null) {
    type = 'deal';
  }
  list = [];
  try {
    switch (type) {
      case 'deal':
        list = JSON.parse(((ref = window.localStorage) != null ? ref.getItem('LS_recentSearches') : void 0) || '[]');
        break;
      case 'location':
        list = JSON.parse(((ref1 = window.localStorage) != null ? ref1.getItem('LS_recentLocations') : void 0) || '[]');
    }
  } catch (error) {}
  return list;
};


/*
 * Sets matching classes to list item when match indicated
 *
 * @param   {Array}  list          - List of items
 * @param   {Number} index         - Index of the item in the list that matched query
 * @returns {Object} {list, index}
 */

matchListItem = function(list, index) {
  var partial;
  if (index > -1) {
    partial = "<a class='typeahead-match typeahead-match-highlight";
    if (list[index].match(/<a class='/)) {
      list[index] = list[index].replace(/<a class='/, partial + " ");
    } else {
      list[index] = list[index].replace(/<a/, partial + "'");
    }
  }
  return {
    list: list,
    index: index
  };
};


/*
 * Move typeahead container into its context.
 * This is only needed for desktop
 *
 * @param {Object} $container - Selector for typeahead wrapper
 * @param {String} ctx        - Typeahead context
 * @param {String} env        - Environment
 */

moveAutocomplete = function($container, ctx, env) {
  var selector;
  if (env === 'desktop') {
    switch (ctx) {
      case 'search':
        selector = '.deal-search';
        break;
      case 'location':
        selector = '.location-search';
    }
    $(selector).append($container);
  }
};


/*
 * Returns Bloodhound tag name
 *
 * @param   {String|Object} value
 * @returns {String}        tag
 */

prepareBloodhoundTag = function(value) {
  var address, division, tag;
  tag = '';
  if (!value) {
    return tag;
  }
  if (typeof value === 'string') {
    tag = value;
  }
  if (typeof value === 'object') {
    division = value.division, address = value.address;
    tag = address || division;
  }
  if (typeof tag === 'string') {
    tag = tag.toLowerCase().replace(/[^\w\d]+/g, '_');
  }
  return tag;
};


/*
 * Convert, prepend and save term to recent searches list
 *
 * @param {String} term   - Deal query entered by user
 * @param {String} [type] - input type (Optional)
 */

removeRecentSearch = function(term, type) {
  var index, keywords;
  if (type == null) {
    type = 'deal';
  }
  if (type === 'search') {
    type = 'deal';
  }
  keywords = getRecentSearches(type) || [];
  term = _.escape(term).trim().toLowerCase();
  switch (type) {
    case 'deal':
      index = keywords.findIndex(function(n) {
        return n.toLowerCase() === term;
      });
      break;
    case 'location':
      index = keywords.findIndex(function(n) {
        var ref;
        return ((ref = n.address) != null ? ref.toLowerCase() : void 0) === term;
      });
  }
  if (index > -1) {
    keywords.splice(index, 1);
  }
  setRecentSearches(keywords, type);
};


/*
 * Helper function to remove stored searches
 *
 * @param {String} type - Input type
 */

removeRecentSearches = function(type) {
  if (type == null) {
    type = 'deal';
  }
  if (type === 'search') {
    type = 'deal';
  }
  switch (type) {
    case 'deal':
      window.localStorage.removeItem('LS_recentSearches');
      RecentSearches = [];
      break;
    case 'location':
      window.localStorage.removeItem('LS_recentLocations');
      RecentLocations = [];
  }
};


/*
 * Saves recent searches array as string in localStorage
 *
 * @param {Array}  keywords - List of keywords searched by user
 * @param {String} type     - input type
 */

setRecentSearches = function(keywords, type) {
  var key, ref;
  switch (type) {
    case 'deal':
      key = 'LS_recentSearches';
      break;
    case 'location':
      key = 'LS_recentLocations';
  }
  try {
    return (ref = window.localStorage) != null ? ref.setItem(key, JSON.stringify(keywords)) : void 0;
  } catch (error) {}
};


/*
 * Convert, prepend and save term to recent searches list
 *
 * @param {String} term - Deal query entered by user
 * @param {String} type - input type (Optional)
 * @param {String} env  - Environment. Controls amount of items (Optional)
 */

saveRecentSearch = function(term, type, env) {
  var amount, index, keywords;
  if (type == null) {
    type = 'deal';
  }
  if (env == null) {
    env = 'desktop';
  }
  amount = type === 'deal' && env === 'mobile' ? 5 : 10;
  keywords = getRecentSearches(type) || [];
  switch (typeof term) {
    case 'string':
      term = _.escape(term).trim().toLowerCase();
      if (term === '') {
        return;
      }
      index = keywords.findIndex(function(n) {
        return n === term;
      });
      break;
    case 'object':
      index = keywords.findIndex(function(n) {
        return n.address === term.address;
      });
  }
  if (index > -1) {
    keywords.move(index, 0);
  } else {
    keywords.unshift(term);
  }
  setRecentSearches(keywords.slice(0, amount), type);
};


/*
 * Cache translations globally and make immutable
 *
 * @param   {Object} [translations]
 * @returns {Object} allTranslations
 */

setTranslations = function(translations) {
  if (translations == null) {
    translations = typeof Groupon !== "undefined" && Groupon !== null ? Groupon.LS.translations : void 0;
  }
  return allTranslations = Object.seal(translations);
};


/*
 * Get subcategory collection and its taxonomy level
 *
 * @param   {Array}                            collections
 * @param   {Array}                            path
 * @param   {Number}                           [level] - Taxonomy level
 * @returns {{collection.Array, level.Number}}
 */

getSubCategoryCollection = function(collections, path, level) {
  var collection, findSubCategory, id, temp;
  if (level == null) {
    level = 1;
  }
  collection = collections;
  id = void 0;

  /*
   * Condition to find matching item with categories
   * Checks if ID (i) matches and if subcategories (s) exists
   *
   * @param   {Object} item  - Array item
   * @returns {Boolean}      - Condition being passed to Array.prototype.find() to return object
   */
  findSubCategory = function(item) {
    var ref;
    return item[0] === id && ((ref = item[3]) != null ? ref.length : void 0);
  };

  /*
   * NOTE: This might be more efficient with Array::reduce
  
    findSubCategory = (item) ->
      if item[0] is id and item[3]?.length
        return item[3]
    level++ if (collection = collection.reduce(findSubCategory))
   */
  while (id = path.shift()) {
    if (temp = collection.find(findSubCategory)) {
      collection = temp[3].slice(0);
      level++;
    }
  }
  return {
    collection: collection,
    level: level
  };
};

module.exports = {
  createBloodhoundTag: createBloodhoundTag,
  getAutocompleteList: getAutocompleteList,
  getHeadingPartial: getHeadingPartial,
  getRecentSearches: getRecentSearches,
  getSubCategoryCollection: getSubCategoryCollection,
  getTranslations: getTranslations,
  deEmphasis: deEmphasis,
  matchListItem: matchListItem,
  moveAutocomplete: moveAutocomplete,
  partialAutocompleteList: partialAutocompleteList,
  partialCurrentLocation: partialCurrentLocation,
  partialLocationHelper: partialLocationHelper,
  partialRecentSearchesList: partialRecentSearchesList,
  partialSearchCategories: partialSearchCategories,
  partialSearchCategoryList: partialSearchCategoryList,
  prepareBloodhoundTag: prepareBloodhoundTag,
  removeRecentSearch: removeRecentSearch,
  removeRecentSearches: removeRecentSearches,
  saveRecentSearch: saveRecentSearch,
  setRecentSearches: setRecentSearches,
  setTranslations: setTranslations,
  templateAttributesForSubcategories: templateAttributesForSubcategories
};

//# sourceMappingURL=data:application/json;base64,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
